var RecentLocations, RecentSearches, allTranslations, createBloodhoundTag, deEmphasis, getAutocompleteList, getHeadingPartial, getRecentSearches, getSubCategoryCollection, getTranslations, matchListItem, moveAutocomplete, normalizeQuery, partialAutocompleteList, partialCurrentLocation, partialLocationHelper, partialRecentSearchesList, partialSearchCategories, partialSearchCategoryList, prepareBloodhoundTag, removeRecentSearch, removeRecentSearches, saveRecentSearch, setRecentSearches, setTranslations, templateAttributesForSubcategories, toCamelCase,
  slice = [].slice;

normalizeQuery = require('./m_normalizeQuery');

toCamelCase = require('../../../../../src/helpers/camelCase').toCamelCase;


/*
 * @type {Object} allTranslations Global closure to cache translations
 */

allTranslations = {};


/*
 * @type {Array} RecentSearches Global closure to cache recent searches terms
 */

RecentSearches = [];


/*
 * @type {Array} RecentLocations Global closure to cache recent location searches
 */

RecentLocations = [];


/*
 * Injects html tags to separate the neighborhood and the city
 *
 * @param   {String} label - Location with strong tags
 * @returns {String}
 */

deEmphasis = function(label) {
  var res;
  res = label.split(/,(.+)?/);
  if (res.length < 2) {
    return label;
  }
  if (res[0].includes('</strong>') || res[1].includes('<strong>')) {
    res.splice(1, 0, '<em>');
  } else {
    res.splice(1, 0, '</strong><em><strong>');
  }
  res.splice(3, 0, '</em>');
  return res.join('');
};


/*
 * Generate basic bloodhound tag name
 *
 * @param   {String} [type]     - Name of the api / collection name
 * @param   {String} attributes
 * @returns {String} bhw        - Base bloodhound tag
 */

createBloodhoundTag = function(type) {
  var bhw;
  if (type == null) {
    type = '';
  }
  type = type.split('|').map(function(i) {
    return toCamelCase(i);
  }).join('');
  bhw = "TouchSearchCategory" + type;
  return bhw;
};


/*
 * Method to build general (deal|location) autocomplete partial
 *
 * @param   {Array}  collections           - List of items returned from autocomplete
 * @param   {String} normQuery             - Normalized term entered by user
 * @param   {Number} [indexShift]          - Shift the index e.g due to previously processed collection
 * @returns {Object} {list, index, prefix}
 */

partialAutocompleteList = function(collections, normQuery, indexShift) {
  var index, item, label, lat, len, list, lng, locationPartial, n, queryLength, template, value;
  if (indexShift == null) {
    indexShift = 0;
  }
  queryLength = normQuery.length + 2;
  len = collections.length - 1;
  index = -1;
  list = [];
  locationPartial = '';
  while (item = collections.shift()) {
    lat = item.lat, lng = item.lng, label = item.label, value = item.value;
    if (lat) {
      locationPartial = " data-lat='" + lat + "' data-lng='" + lng + "'";
      if (item.neighborhood) {
        label = deEmphasis(label);
      }
    }
    n = len - collections.length;
    if (queryLength >= value.length && normQuery === normalizeQuery(value)) {
      index = n + indexShift;
    }
    template = "<li role='listitem' class='tw-item'>\n<a class='tw-link' id='tw" + n + "' tabindex='0' data-bhc='result-" + n + ":" + value + "' data-value='" + value + "'" + locationPartial + ">" + label + "</a>\n</li>";
    list.push(template);
  }
  return {
    list: list,
    index: index,
    prefix: 'tw'
  };
};


/*
 * LS-2211 current location / geolocation
 * Adds geolocation partial and handles matching
 *
 * @param   {String} widget         - Widget name
 * @param   {String} normQuery      - Normalized term user entered
 * @param   {Number} index          - Matched item index
 * @returns {Object} {list, index}
 */

partialCurrentLocation = function(widget, normQuery, index) {
  var list, normLabel, template, translations;
  translations = getTranslations();
  normLabel = normalizeQuery(translations.search.currentlocation);
  template = "<li role='listitem'>\n<a class='current-location icon-compass-needle tw-link' tabindex='0' data-value='" + translations.search.currentlocation + "' data-bhw='" + widget + "'>" + translations.search.currentlocation + "</a>\n</li>";
  list = [template];
  if (index > -1) {
    index = index + 1;
  }
  if (normQuery === normLabel) {
    index = index + 1;
  }
  return {
    list: list,
    index: index
  };
};


/*
 * LS-2685 Location Helper message
 * Adds message to help users when searching locations
 *
 * @returns {Array}
 */

partialLocationHelper = function() {
  var template, text, translations;
  translations = getTranslations();
  text = translations.search.helpermsg;
  template = "<li role='listitem'>\n<span class='tw-msg ls-location-helper'><span class=\"new-badge\">NEW</span>" + text + "</span>\n</li>";
  return [template];
};


/*
 * Adds recent searches partial
 *
 * @param   {String} widget         - Widget name
 * @param   {Array}  collection     - List of items to build recent searches widget
 * @param   {Object} [config]       - Configuration containing experiments settings, etc. (Optional)
 * @returns {Object} {list, prefix}
 */

partialRecentSearchesList = function(widget, collection, config) {
  var address, bhc, clearingHeadingPartial, clearingPartial, ctx, division, hasClearingExperiment, item, lat, list, lng, n, ref, template, text, translations;
  if (config == null) {
    config = {};
  }
  translations = getTranslations();
  list = [];
  text = '';
  n = 0;
  clearingPartial = '';
  clearingHeadingPartial = '';
  if ((hasClearingExperiment = (ref = config.experiments) != null ? ref['LS-1744-clear-recent-searches'] : void 0) && (hasClearingExperiment != null ? hasClearingExperiment.setClearX : void 0)) {
    clearingPartial = "<span class='tw-clear icon-x' tabindex='0' aria-label='" + translations.ax.remove + "'></span>";
  }
  switch (widget) {
    case 'recentSearches':
      text = translations.search.recentdeals;
      ctx = 'deal';
      while (item = collection.shift()) {
        bhc = prepareBloodhoundTag(item);
        template = "<li role='listitem' class='tw-item tw-recent'>\n<a class='tw-link' id='twr" + n + "' tabindex='0' data-bhc='" + widget + ":" + bhc + "' data-value='" + item + "'>" + item + "</a>" + clearingPartial + "\n</li>";
        list.push(template);
        n++;
      }
      break;
    case 'recentLocations':
      text = translations.search.recentlocations;
      ctx = 'location';
      while (item = collection.shift()) {
        lat = item.lat, lng = item.lng, address = item.address, division = item.division;
        bhc = prepareBloodhoundTag(address);
        division = division ? "data-division='" + division + "'" : '';
        template = "<li role='listitem' class='tw-item tw-recent'>\n<a class='tw-link' id='twr" + n + "' tabindex='0' data-bhc='" + widget + ":" + bhc + "' data-lat='" + lat + "' data-lng='" + lng + "' data-value='" + address + "' " + division + ">" + address + "</a>" + clearingPartial + "\n</li>";
        list.push(template);
        n++;
      }
  }
  if (list.length) {
    if (hasClearingExperiment && (hasClearingExperiment != null ? hasClearingExperiment.setClearAll : void 0)) {
      clearingHeadingPartial = "<span class='tw-clear' ctx='" + ctx + "'>" + translations.search.clearall + "</span>";
    }
    list.unshift("<li class='tw-heading tw-recent'>" + text + clearingHeadingPartial + "</li>");
  }
  return {
    list: list,
    prefix: 'twr'
  };
};


/*
 * Build L1 Category header partial
 *
 * @param   {String}  type           - category type
 * @returns {String}  partial        - HTML partial containing L0 category heading
 */

getHeadingPartial = function(type) {
  var partial, translations, txt;
  translations = getTranslations();
  partial = '';
  txt = translations != null ? translations.categories[type] : void 0;
  return partial = txt ? "<div class='tw-heading tw-" + type + "'>" + txt + "</div>" : '';
};

templateAttributesForSubcategories = function() {
  var args, ariaAttributes, ariaListAttributes, bhw, catInfo, htmlCloseTag, htmlOpenTag, id, menuID, prefix, sectionID;
  args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  id = args[0], sectionID = args[1], prefix = args[2], bhw = args[3];
  htmlOpenTag = 'span class="icon-plus tw-caption"';
  htmlCloseTag = 'span';
  menuID = prefix + "tw-" + id + "-menu";
  ariaAttributes = " role='link' aria-controls='" + menuID + "' aria-owns='" + menuID + "' aria-haspopup='true' ";
  catInfo = " cat='" + id + "' cat-path='" + sectionID + "|" + id + "'";
  ariaListAttributes = ' aria-live="polite"';
  return [htmlOpenTag, htmlCloseTag, ariaAttributes, ariaListAttributes, catInfo];
};


/*
 * Build Category partial
 *
 * @param   {Array}   collection - List of items
 * @param   {String}  sectionID  - category section name
 * @param   {Number}  [level]    - Optional parameter representing the taxonomy
 * @param   {Number}  [prefix]   - Optional prefix for id generation
 * @returns {String}             - HTML String
 */

partialSearchCategoryList = function(collection, sectionID, level, prefix) {
  var ariaAttributes, ariaListAttributes, attributes, baseBHW, baseObject, baseUrl, bhw, catInfo, count, countString, friendlyName, htmlCloseTag, htmlOpenTag, id, item, list, menuID, newBadge, newBadgeTag, newBadgeTxt, subcategories, template, url;
  if (level == null) {
    level = 1;
  }
  if (prefix == null) {
    prefix = '';
  }
  if (!(collection != null ? collection.length : void 0)) {
    return '';
  }
  list = [];
  url = '';
  baseBHW = createBloodhoundTag(sectionID);
  baseObject = collection.shift();
  baseUrl = baseObject.baseUrl;
  if (!baseUrl) {
    baseUrl = false;
    collection.unshift(baseObject);
  }
  while (item = collection.shift()) {

    /*
     * item can be either of type "Array" or "Object"
     * API facets are normally mapped as arrays
     * while config or constructed entries (all deals) ar
     * mapped as object.
     */
    if (Array.isArray(item)) {
      if (!baseUrl) {
        continue;
      }
      id = item[0], friendlyName = item[1], count = item[2], subcategories = item[3];
      url = baseUrl + id;
    } else {
      id = item.i, friendlyName = item.n, count = item.c, subcategories = item.s, url = item.u, newBadge = item.newBadge;
    }
    ariaAttributes = ariaListAttributes = catInfo = newBadgeTag = '';
    countString = count ? " <span class='tw-count'>(" + count + ")</span>" : '';
    bhw = id ? baseBHW + toCamelCase(id) : baseBHW + 'AllDeal';
    if (newBadge && (newBadgeTxt = allTranslations.general.newbadge)) {
      newBadgeTag = "<span class='new-badge'>" + newBadgeTxt + "</span>";
    }
    if (subcategories != null ? subcategories.length : void 0) {
      attributes = templateAttributesForSubcategories(id, sectionID, prefix, bhw);
      htmlOpenTag = attributes[0], htmlCloseTag = attributes[1], ariaAttributes = attributes[2], ariaListAttributes = attributes[3], catInfo = attributes[4];
    } else {
      url = url ? "href='" + url + "' " : '';
      htmlOpenTag = "a " + url + "class='tw-link'";
      htmlCloseTag = 'a';
    }
    template = "<li class='tw-item tw-cat-item tw-cat-L" + level + "'" + ariaListAttributes + ">\n<" + htmlOpenTag + " data-bhw='" + bhw + "' " + catInfo + " " + ariaAttributes + ">" + newBadgeTag + friendlyName + countString + "</" + htmlCloseTag + ">\n</li>";
    list.push(template);
  }
  if (list.length) {
    menuID = sectionID.split('|').pop();
    list.unshift("<ul id='" + prefix + "tw-" + menuID + "-menu' class='tw-cat-menu tw-cat-menu-L" + level + "'>");
    list.push("</ul>");
  }
  return list.join('');
};


/*
 * Build Category lists and wrap them
 *
 * @param   {Array}   collections    - List of items
 * @param   {Array}   [prefix]       - Prefix for id generation (Optional)
 * @param   {Boolean} [m2016]        - Mobile2016 flag (Optional)
 * @returns {Object}  {list[]}       - List of categories
 */

partialSearchCategories = function(collections, prefix, m2016) {
  var collection, heading, item, listItems, type;
  if (prefix == null) {
    prefix = '';
  }
  if (m2016 == null) {
    m2016 = true;
  }
  item = collections[0];
  listItems = [];
  for (type in item) {
    collection = item[type];
    if (collection != null ? collection.length : void 0) {
      heading = getHeadingPartial(type);
      listItems.push("<li id='" + prefix + "tw-" + type + "' class='tw-category'>" + heading);
      listItems.push(partialSearchCategoryList(collection.slice(0), type, 1, prefix, m2016));
      listItems.push("</li>");
    }
  }
  return {
    list: listItems
  };
};


/*
 * Global method to generate the autocomplete list
 *
 * @param   {Array}  collections               - List of collections to process
 * @param   {String} query                     - Term entered by user
 * @param   {Object} [config]                  - Config object
 * @returns {Object} {list, index, bh, prefix}
 */

getAutocompleteList = function(collections, query, config) {
  var bh, data, finalList, index, indexShift, j, len1, list, normQuery, prefix, ref, ref1, ref2, ref3, ref4, ref5, tempList, widget;
  if (config == null) {
    config = {};
  }
  tempList = [];
  index = -1;
  indexShift = 0;
  prefix = '';
  normQuery = normalizeQuery(query);
  for (j = 0, len1 = collections.length; j < len1; j++) {
    ref = collections[j], data = ref.collection, widget = ref.widget;
    switch (widget) {
      case 'autocomplete':
        if (query) {
          ref1 = partialAutocompleteList(data, normQuery, indexShift), list = ref1.list, index = ref1.index, prefix = ref1.prefix;
        }
        break;
      case 'helperMessage':
        list = partialLocationHelper();
        break;
      case 'geolocation':
        ref2 = partialCurrentLocation(widget, normQuery, index), list = ref2.list, index = ref2.index;
        indexShift += list.length;
        break;
      case 'recentLocations':
        ref3 = partialRecentSearchesList(widget, data, config), list = ref3.list, prefix = ref3.prefix;
        break;
      case 'recentSearches':
        ref4 = partialRecentSearchesList(widget, data, config), list = ref4.list, prefix = ref4.prefix;
        break;
      case 'searchCategories':
        list = partialSearchCategories(data).list;
    }
    tempList.push.apply(tempList, list);
  }
  bh = widget === 'autocomplete' ? {
    type: 'bhc',
    val: "UserTyped:" + query
  } : {
    type: 'bhw',
    val: toCamelCase(widget)
  };
  ref5 = matchListItem(tempList, index), finalList = ref5.list, index = ref5.index;
  return {
    list: finalList,
    index: index,
    bh: bh,
    prefix: prefix
  };
};


/*
 * Get translations
 *
 * @param   {String} [key]
 * @returns {Object} translations - All translations or partial
 */

getTranslations = function(key) {
  var ref, translations;
  if (!Object.keys(allTranslations).length) {
    setTranslations((ref = Groupon.LS) != null ? ref.translations : void 0);
  }
  translations = typeof key === 'string' ? allTranslations[key] : allTranslations;
  return translations || {};
};


/*
 * Returns list of recent searches queries retrieved from localStorage
 *
 * param    {String} - Input type
 * @returns {Array}  - list
 */

getRecentSearches = function(type) {
  var list, ref, ref1;
  if (type == null) {
    type = 'deal';
  }
  list = [];
  try {
    switch (type) {
      case 'deal':
        list = JSON.parse(((ref = window.localStorage) != null ? ref.getItem('LS_recentSearches') : void 0) || '[]');
        break;
      case 'location':
        list = JSON.parse(((ref1 = window.localStorage) != null ? ref1.getItem('LS_recentLocations') : void 0) || '[]');
    }
  } catch (error) {}
  return list;
};


/*
 * Sets matching classes to list item when match indicated
 *
 * @param   {Array}  list          - List of items
 * @param   {Number} index         - Index of the item in the list that matched query
 * @returns {Object} {list, index}
 */

matchListItem = function(list, index) {
  var partial;
  if (index > -1) {
    partial = "<a class='typeahead-match typeahead-match-highlight";
    if (list[index].match(/<a class='/)) {
      list[index] = list[index].replace(/<a class='/, partial + " ");
    } else {
      list[index] = list[index].replace(/<a/, partial + "'");
    }
  }
  return {
    list: list,
    index: index
  };
};


/*
 * Move typeahead container into its context.
 * This is only needed for desktop
 *
 * @param {Object} $container - Selector for typeahead wrapper
 * @param {String} ctx        - Typeahead context
 * @param {String} env        - Environment
 */

moveAutocomplete = function($container, ctx, env) {
  var selector;
  if (env === 'desktop') {
    switch (ctx) {
      case 'search':
        selector = '.deal-search';
        break;
      case 'location':
        selector = '.location-search';
    }
    $(selector).append($container);
  }
};


/*
 * Returns Bloodhound tag name
 *
 * @param   {String|Object} value
 * @returns {String}        tag
 */

prepareBloodhoundTag = function(value) {
  var address, division, tag;
  tag = '';
  if (!value) {
    return tag;
  }
  if (typeof value === 'string') {
    tag = value;
  }
  if (typeof value === 'object') {
    division = value.division, address = value.address;
    tag = address || division;
  }
  if (typeof tag === 'string') {
    tag = tag.toLowerCase().replace(/[^\w\d]+/g, '_');
  }
  return tag;
};


/*
 * Convert, prepend and save term to recent searches list
 *
 * @param {String} term   - Deal query entered by user
 * @param {String} [type] - input type (Optional)
 */

removeRecentSearch = function(term, type) {
  var index, keywords;
  if (type == null) {
    type = 'deal';
  }
  if (type === 'search') {
    type = 'deal';
  }
  keywords = getRecentSearches(type) || [];
  term = _.escape(term).trim().toLowerCase();
  switch (type) {
    case 'deal':
      index = keywords.findIndex(function(n) {
        return n.toLowerCase() === term;
      });
      break;
    case 'location':
      index = keywords.findIndex(function(n) {
        var ref;
        return ((ref = n.address) != null ? ref.toLowerCase() : void 0) === term;
      });
  }
  if (index > -1) {
    keywords.splice(index, 1);
  }
  setRecentSearches(keywords, type);
};


/*
 * Helper function to remove stored searches
 *
 * @param {String} type - Input type
 */

removeRecentSearches = function(type) {
  if (type == null) {
    type = 'deal';
  }
  if (type === 'search') {
    type = 'deal';
  }
  switch (type) {
    case 'deal':
      window.localStorage.removeItem('LS_recentSearches');
      RecentSearches = [];
      break;
    case 'location':
      window.localStorage.removeItem('LS_recentLocations');
      RecentLocations = [];
  }
};


/*
 * Saves recent searches array as string in localStorage
 *
 * @param {Array}  keywords - List of keywords searched by user
 * @param {String} type     - input type
 */

setRecentSearches = function(keywords, type) {
  var key, ref;
  switch (type) {
    case 'deal':
      key = 'LS_recentSearches';
      break;
    case 'location':
      key = 'LS_recentLocations';
  }
  try {
    return (ref = window.localStorage) != null ? ref.setItem(key, JSON.stringify(keywords)) : void 0;
  } catch (error) {}
};


/*
 * Convert, prepend and save term to recent searches list
 *
 * @param {String} term - Deal query entered by user
 * @param {String} type - input type (Optional)
 * @param {String} env  - Environment. Controls amount of items (Optional)
 */

saveRecentSearch = function(term, type, env) {
  var amount, index, keywords;
  if (type == null) {
    type = 'deal';
  }
  if (env == null) {
    env = 'desktop';
  }
  amount = type === 'deal' && env === 'mobile' ? 5 : 10;
  keywords = getRecentSearches(type) || [];
  switch (typeof term) {
    case 'string':
      term = _.escape(term).trim().toLowerCase();
      if (term === '') {
        return;
      }
      index = keywords.findIndex(function(n) {
        return n === term;
      });
      break;
    case 'object':
      index = keywords.findIndex(function(n) {
        return n.address === term.address;
      });
  }
  if (index > -1) {
    keywords.move(index, 0);
  } else {
    keywords.unshift(term);
  }
  setRecentSearches(keywords.slice(0, amount), type);
};


/*
 * Cache translations globally and make immutable
 *
 * @param   {Object} [translations]
 * @returns {Object} allTranslations
 */

setTranslations = function(translations) {
  if (translations == null) {
    translations = typeof Groupon !== "undefined" && Groupon !== null ? Groupon.LS.translations : void 0;
  }
  return allTranslations = Object.seal(translations);
};


/*
 * Get subcategory collection and its taxonomy level
 *
 * @param   {Array}                            collections
 * @param   {Array}                            path
 * @param   {Number}                           [level] - Taxonomy level
 * @returns {{collection.Array, level.Number}}
 */

getSubCategoryCollection = function(collections, path, level) {
  var collection, findSubCategory, id, temp;
  if (level == null) {
    level = 1;
  }
  collection = collections;
  id = void 0;

  /*
   * Condition to find matching item with categories
   * Checks if ID (i) matches and if subcategories (s) exists
   *
   * @param   {Object} item  - Array item
   * @returns {Boolean}      - Condition being passed to Array.prototype.find() to return object
   */
  findSubCategory = function(item) {
    var ref;
    return item[0] === id && ((ref = item[3]) != null ? ref.length : void 0);
  };

  /*
   * NOTE: This might be more efficient with Array::reduce
  
    findSubCategory = (item) ->
      if item[0] is id and item[3]?.length
        return item[3]
    level++ if (collection = collection.reduce(findSubCategory))
   */
  while (id = path.shift()) {
    if (temp = collection.find(findSubCategory)) {
      collection = temp[3].slice(0);
      level++;
    }
  }
  return {
    collection: collection,
    level: level
  };
};

module.exports = {
  createBloodhoundTag: createBloodhoundTag,
  getAutocompleteList: getAutocompleteList,
  getHeadingPartial: getHeadingPartial,
  getRecentSearches: getRecentSearches,
  getSubCategoryCollection: getSubCategoryCollection,
  getTranslations: getTranslations,
  deEmphasis: deEmphasis,
  matchListItem: matchListItem,
  moveAutocomplete: moveAutocomplete,
  partialAutocompleteList: partialAutocompleteList,
  partialCurrentLocation: partialCurrentLocation,
  partialLocationHelper: partialLocationHelper,
  partialRecentSearchesList: partialRecentSearchesList,
  partialSearchCategories: partialSearchCategories,
  partialSearchCategoryList: partialSearchCategoryList,
  prepareBloodhoundTag: prepareBloodhoundTag,
  removeRecentSearch: removeRecentSearch,
  removeRecentSearches: removeRecentSearches,
  saveRecentSearch: saveRecentSearch,
  setRecentSearches: setRecentSearches,
  setTranslations: setTranslations,
  templateAttributesForSubcategories: templateAttributesForSubcategories
};

//# sourceMappingURL=data:application/json;base64,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
